import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { InsuredNavigationItem } from '@app/layout/sidebar/models/insured-navigation-item.model'

@Component({
  selector: 'albert-list-view-insured-list-item',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './list-view-insured-list-item.html',
  styleUrl: './list-view-insured-list-item.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewInsuredListItem {
  public readonly itemClicked = output()
  public readonly item = input.required<InsuredNavigationItem>()
  //Used for highlighting the insured, when i.e. displaying one of it's certificates
  public readonly selected = input<boolean>(false)

  public onEntryClick(): void {
    this.itemClicked.emit()
  }
}
